import axios from 'axios'

export default {
  firstSubmitList (params) {
    return axios.post('/api/rendering/admin/task/user/first/submit/list', params)
  },
  firstSubmitRemark(params) {
    return axios.post('/api/rendering/admin/task/user/first/submit/remark', params)
  },
  firstSubmitExport(params) {
    return axios.post('/api/rendering/admin/task/user/first/submit/export', params)
  },
  getCgInfo(params) {
    return axios.post('/api/rendering/admin/task/user/first/submit/getCgInfo', params)
  },
  getPlatformInfo(params) {
    return axios.post('/api/rendering/admin/task/user/first/submit/getPlatformInfo', params)
  },
}
